var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 90,
    viewBox: "0 0 97 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 18.75H48.25V52.5H37V63.75H29.5V52.5H18.25V18.75H29.5V7.5H37V18.75ZM25.75 26.25V45H40.75V26.25H25.75ZM74.5 37.5H85.75V71.25H74.5V82.5H67V71.25H55.75V37.5H67V26.25H74.5V37.5ZM63.25 45V63.75H78.25V45H63.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 18.75V19.25H30H40.75V52H30H29.5V52.5V63.25H23V52.5V52H22.5H11.75V19.25H22.5H23V18.75V8H29.5V18.75ZM18.75 25.75H18.25V26.25V45V45.5H18.75H33.75H34.25V45V26.25V25.75H33.75H18.75ZM67 37.5V38H67.5H78.25V70.75H67.5H67V71.25V82H60.5V71.25V70.75H60H49.25V38H60H60.5V37.5V26.75H67V37.5ZM56.25 44.5H55.75V45V63.75V64.25H56.25H71.25H71.75V63.75V45V44.5H71.25H56.25Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService6);
export default __webpack_public_path__ + "static/media/Service6.8443bbba3962db676fb8b5f1dd3a746e.svg";
export { ForwardRef as ReactComponent };